<app-breadcrumb [title]="'institution'|translate" [items]="['institution'|translate]" [active_item]="'institution'|translate"></app-breadcrumb>

<div class="container-fluid">
  <div class="edit-profile">

    <form class="row" [formGroup]="institutionForm" (ngSubmit)="onFormSubmit()" id="ngForm">

        <div class="col-xl-4">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title mb-0 f-w-700">{{'logo'|translate}}</h5>
                <ng-template *ngIf="loadForm === false; else isLoadForm"> </ng-template>
                <ng-template #isLoadForm>
                  <div class="card-header-right">
                    <ul class="list-unstyled card-option">
                      <li><i class="fa fa-spin fa-cog"></i></li>
                    </ul>
                  </div>
                </ng-template>
                <div class="card-options">
                  <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
                </div>
              </div>

                <div class="card-body">
                    <div>
                      <div class="row mb-2">
                        <div class="col-auto">
                          <img class="img-70 rounded-circle" alt="" src="{{defaultImg}}" />
                        </div>
                        <div class="col">
                          <h5 class="mb-1">{{printInstitutionCode}}</h5>
                          <p class="mb-4">{{printInstitutionName}}</p>
                        </div>
                      </div>

                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{'picture'|translate}} </label>
                        <input class="form-control form-control-sm" type="file" (change)="onChange($event)" formControlName="file" [ngClass]="{'is-invalid': fc['file'].invalid && isSubmitted}">
                        <div class="invalid-feedback fst-italic" *ngIf="fc['file'].errors?.['serverError']">
                          {{ fc['file'].errors?.['serverError'] }}
                        </div>
                      </div>

                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{'website'|translate}}</label>
                        <input class="form-control form-control-sm" type="text" placeholder="Ex. 3w.bp.cm" formControlName="website" [ngClass]="{'is-invalid': fc['website'].invalid && isSubmitted}">
                        <div class="invalid-feedback fst-italic" *ngIf="fc['website'].errors?.['serverError']">
                          {{ fc['website'].errors?.['serverError'] }}
                        </div>
                      </div>

                        <div class="col-md-12 mb-1">
                            <label class="form-label">{{'address'|translate}}</label>
                            <input class="form-control form-control-sm" type="text" placeholder="Ex. BP 237 ssadi" formControlName="address" [ngClass]="{'is-invalid': fc['address'].invalid && isSubmitted}">
                            <div class="invalid-feedback fst-italic" *ngIf="fc['address'].errors?.['serverError']">
                                {{ fc['address'].errors?.['serverError'] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-end mb-4"></div>
          </div>
        </div>

      <div class="col-xl-8">
        <div class="card" >
          <div class="card-header">
            <h5 class="card-title mb-0 f-w-700">{{'profile'|translate}}</h5>
            <ng-template *ngIf="loadForm === false; else isLoadForm"> </ng-template>
            <ng-template #isLoadForm>
              <div class="card-header-right">
                <ul class="list-unstyled card-option">
                  <li><i class="fa fa-spin fa-cog"></i></li>
                </ul>
              </div>
            </ng-template>
            <div class="card-options">
              <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <label class="form-label">{{'code'|translate}} <span class="text-danger">*</span></label>
                <input (keyup)="onKey($event)" class="form-control form-control-sm" type="text" placeholder="Ex. BPL" formControlName="code" [ngClass]="{'is-invalid': fc['code'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['code'].errors?.['required']">{{'this field is required'|translate}}</small>
                <!--<div class="invalid-feedback fst-italic" *ngIf="fc['code'].errors?.['minlength']">{{'code must be atleast 3 caracters long'|translate}}</div>-->
                <div class="invalid-feedback fst-italic" *ngIf="fc['code'].errors?.['serverError']">
                  {{ fc['code'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-8">
                <label class="form-label">{{'name'|translate}} <span class="text-danger">*</span></label>
                <input (keyup)="onKey2($event)" class="form-control form-control-sm" type="text" placeholder="Ex. Better Plan" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">{{'this field is required'|translate}}</small>
                <!--<div class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['minlength']">{{'name must be atleast 3 caracters long'|translate}}</div>-->
                <div class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['serverError']">
                  {{ fc['name'].errors?.['serverError'] }}
                </div>
              </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-4">
                    <label class="form-label">{{'email'|translate}} </label>
                    <input class="form-control form-control-sm" type="text" placeholder="Ex. jdoe@bp.com" formControlName="email" [ngClass]="{'is-invalid': fc['email'].invalid && isSubmitted}">
                    <!--<small class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['required']">{{'this field is required'|translate}}</small>-->
                    <small class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['email']">{{'email must respect mail convention'|translate}}</small>
                    <div class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['serverError']">
                        {{ fc['email'].errors?.['serverError'] }}
                    </div>
                </div>
              <div class="col-md-4">
                <label class="form-label">{{'phone'|translate}} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="number" placeholder="Ex. 677777777" formControlName="phone" [ngClass]="{'is-invalid': fc['phone'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['phone'].errors?.['required']">{{'this field is required'|translate}}</small>
                <!--<div class="invalid-feedback fst-italic" *ngIf="fc['phone'].errors?.['pattern']">{{'phone must between 1 - 9'|translate}}</div>-->
                <div class="invalid-feedback fst-italic" *ngIf="fc['phone'].errors?.['serverError']">
                  {{ fc['phone'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{'postal Code'|translate}}</label>
                <input class="form-control form-control-sm" type="number" placeholder="Ex. 237" formControlName="postalCode" [ngClass]="{'is-invalid': fc['postalCode'].invalid && isSubmitted}">
                <div class="invalid-feedback fst-italic" *ngIf="fc['postalCode'].errors?.['serverError']">
                  {{ fc['postalCode'].errors?.['serverError'] }}
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-4">
                <label class="form-label">{{'city'|translate}}</label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. Douala" formControlName="city" [ngClass]="{'is-invalid': fc['city'].invalid && isSubmitted}">
                <div class="invalid-feedback fst-italic" *ngIf="fc['city'].errors?.['serverError']">
                  {{ fc['city'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{'region'|translate}}</label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. Littoral" formControlName="region" [ngClass]="{'is-invalid': fc['region'].invalid && isSubmitted}">
                <div class="invalid-feedback fst-italic" *ngIf="fc['region'].errors?.['serverError']">
                  {{ fc['region'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{'country'|translate}}</label>
                <ng-select
                        [items]="countries"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="{{'choose a country'| translate}}"
                        formControlName="country"
                        [ngClass]="{'is-invalid': fc['country'].invalid && isSubmitted}"
                        [(ngModel)]="countrySelected">
                </ng-select>
                <div class="invalid-feedback fst-italic" *ngIf="fc['country'].errors?.['serverError']">
                  {{ fc['country'].errors?.['serverError'] }}
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-4">
                <label class="form-label">{{'manager type'|translate}} </label>
                <ng-select
                        [items]="managerTypes"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="{{'choose a manager type'| translate}}"
                        formControlName="managerType"
                        [ngClass]="{'is-invalid': fc['managerType'].invalid && isSubmitted}"
                        [(ngModel)]="managerTypeSelected">
                </ng-select>
                <div class="invalid-feedback fst-italic" *ngIf="fc['managerType'].errors?.['serverError']">
                  {{ fc['managerType'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{'manager'|translate}}</label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. jdoe" formControlName="manager" [ngClass]="{'is-invalid': fc['manager'].invalid && isSubmitted}">
                <div class="invalid-feedback fst-italic" *ngIf="fc['manager'].errors?.['serverError']">
                  {{ fc['manager'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
                <div class="btn-radio" >
                    <div class="btn-group" data-bs-toggle="buttons">
                        <div class="btn btn-light txt-dark">
                            <div class="radio radio-dark">
                                <input id="radio21" formControlName="isEnable" type="radio" value='1'>
                                <label for="radio21">{{ 'yes'|translate }}</label>
                            </div>
                        </div>
                        <div class="btn btn-light txt-dark">
                            <div class="radio radio-dark">
                                <input id="radio22" formControlName="isEnable" type="radio" value='0'>
                                <label for="radio22">{{ 'no'|translate }}</label>
                            </div>
                        </div>
                    </div>
                </div>
              </div>

            </div>
          </div>

          <div class="card-footer text-end">

            <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-primary m-r-10">
              <i class="fa fa-save" *ngIf="!saving; else isSaving" style="margin-right: 5px;"></i>
              <ng-template #isSaving>
                <i class="fa fa-spin fa-spinner me-2"></i>
              </ng-template>
              {{ 'update'|translate }}
            </button>

            <button  type="button" style="margin-right: 10px;" class="btn btn-sm btn-outline-dark" routerLink='/security/institutions'>
              <i class="icofont icofont-ui-close" style="margin-right: 2px;"></i>
              {{ 'close'|translate }}
            </button>
            
          </div>

        </div>
      </div>

    </form>

  </div>
</div>














<!--  <form [formGroup]="userForm" (ngSubmit)="onFormSubmit()" id="ngForm">-->




<!--    <div class="row">-->
<!--      <div class="col-md-12">-->
<!--        <label class="form-label">Picture </label>-->
<!--        <input class="form-control form-control-sm" type="file" (change)="onChange($event)" placeholder="Ex. Security" formControlName="file" [ngClass]="{'is-invalid': fc['file'].invalid && isSubmitted}">-->
<!--        <div class="invalid-feedback" *ngIf="fc['file'].errors?.['serverError']">-->
<!--          {{ fc['file'].errors?.['serverError'] }}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--  </form>-->















